// extracted by mini-css-extract-plugin
module.exports = {"comment-cell":"hPZczK7y75WwWaJ-bmHKI"};